import {Button} from '@mui/material';
import styled from 'styled-components';

const StyledButton = styled(Button)`
	padding: 8px 16px;
`;
export {StyledButton};
